<div class="common-table-container" [class.has-extra-bottom-spacing]="hasExtraBottomSpacing" [class.mobile-tablet-scrolling-pagination]="isMobileTabletViewScrollingAndPaginationChanges"
[class.]
  [class.fixed-pagination]="fixedPagination || fullHeight" [class.table-scroll-enabled]="enableTableScroll || fullHeight"
  [style.--scroll-table-height]="fullHeight ? tableHeight : null">
  <!-- Added by amisha on 04/20/2026 to limit full-table loading to the true initial staff load only.
       Reason: refresh scenarios now use body-only or collapsed-body loaders so the frame stays visible. -->
  <!-- Added by amisha on 04/20/2026 to switch the fully scrollable blue-line implementation into body-collapsed mode.
       Reason: keep the header, progress line, and pagination visible during row refreshes. -->
  <!-- Added by amisha on 2026-08-24 to mark every common-table loading mode as non-scrollable.
       Reason: loader appearance must not introduce scrollbars or change the visible header span. -->
  <!-- Updated by amisha on 2026-09-15.
       Reason: make the underlying table non-interactive while its mobile inline-expansion screen is open. -->
  <div class="table-wrapper" [attr.inert]="showMobileInlineExpansionOverlay ? '' : null" [class.loading]="
  (tableType === 'Staff' && isLoading && !effectiveLoadingData && !showCollapsedBodyLoader)"
  [class.loader-active]="showInitialSkeletonLoader || showApplicationBodySkeletonLoader || showFixedScrollSkeletonLoader || showCollapsedBodyLoader"
  [class.body-collapsed-loading]="showCollapsedBodyLoader"
    #wrapperRef [ngClass]="tableType"
    [class.first-column-checkbox]="tableType === 'Staff' && columns?.[0]?.headerType === 'checkbox'"

  [class.no-data-state]="
  (tableType === 'Staff' && ((!isLoading || effectiveLoadingData) && !data?.length && !effectiveLoadingData)) ||
  (tableType === 'Applicant' && (!isLoading && !loadingDataForApplication && !data?.length))
">
  <!--code added by Krutika -->
    <!-- [class.no-data-state]="!data?.length && !loadingData"> -->

    <!-- <div *ngIf="isLoading" class="table-loader-wrapper">
    <div class="table-loader"></div>
    <wm-common-text class="loader-text" [data]="{ text: 'Loading...' }"></wm-common-text>
  </div> -->

  <!-- <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar> -->
  <!-- added by priya 10-02-2026 -->
    <!-- Added by amisha on 04/20/2026 to keep the original full-table skeleton only for the initial fixed-scroll staff load.
         Reason: refresh states must no longer replace the table header and pagination. -->
    <div *ngIf="showInitialSkeletonLoader">

    <div *ngIf="loaderType === 'Skeleton'" class="table-skeleton-wrapper"> <!-- added by Vipul on 25-03-2026-->
      <ngx-skeleton-loader count="1" appearance="circle" [theme]="{ height: '30px', width: tableType === 'Applicant' ? '95%' : '99%',borderRadius:'15px' }" />
      <div class="table-skeleton">
        <div *ngFor="let r of skeletonRows">
          <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px', width: '20%', borderRadius:'15px' }">
          </ngx-skeleton-loader>

            <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px', width: '30%',borderRadius:'15px'  }">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px', width: '10%',borderRadius:'15px'  }">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px', width: '10%',borderRadius:'15px'  }">
            </ngx-skeleton-loader>

             <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px',     width: tableType === 'Applicant' ? '20%' : '25%',
borderRadius:'15px'  }">
          </ngx-skeleton-loader>
          </div>
        </div>
      </div>

      <!-- added by Vipul on 25-03-2026-->
      <div *ngIf="loaderType === 'Circular'">
        <div class="data-table-loader">
          <mat-progress-spinner mode="indeterminate" diameter="48">
          </mat-progress-spinner>
          <wm-common-text [data]="{text:'Retrieving data, please wait…'}"></wm-common-text>
        </div>
      </div>
    </div>
    <!-- end by priya 10-02-2026 -->

    <div *ngIf="errorMessage" class="table-error-wrapper">
      @if(showErrorIcon){
        <wm-common-icon [data]="{iconName:errorIcon}"></wm-common-icon>
      }
      <wm-common-text class="error-text" [data]="{ text: errorMessage }"></wm-common-text>
      <button *ngIf="showRetryButton" class="retry-btn" (click)="onRetry()">
        Retry
      </button>
    </div>
    <ng-container *ngIf="!errorMessage">
      <ng-container *ngIf="tableType === 'Applicant'">
      <!-- Sort change handler added in 04-02-2026 -->
      <!-- Added by amisha on 09-02-2026 for inline expanded row card design in application table and staff table. -->
      <!-- Added by amisha on 2026-04-01 to switch inline-expansion layout only while a row is open and avoid changing the default table width. -->
      <!-- Added by amisha on 04/20/2026 to hide only application rows during refresh.
           Reason: the first body-only skeleton flow must keep the header row rendered. -->
      <!-- Added by amisha on 2026-08-24 to support opt-in fixed widths in the application render path.
           Reason: server-side sorting must not resize columns based on newly returned values. -->
      <!-- Updated by Amisha on 2026-08-27.
           Reason: release fixed widths only while inline expansion is open so the expanded card fits the viewport. -->
      <!-- Updated by amisha on 2026-09-15.
           Reason: release application table widths only for table-row expansion; mobile expansion renders outside the table. -->
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
        [class.initial-skeleton-table]="showInitialSkeletonLoader"
        [class.fixed-column-widths]="fixedColumnWidths && !showInlineExpansionInTable"
        [class.body-loading-table]="showApplicationBodySkeletonLoader || showFixedScrollSkeletonLoader"
        [class.inline-expansion-table]="showInlineExpansionInTable"
        (matSortChange)="handleSortChange($event)">
        <ng-container *ngFor="let col of columns; let i = index" [matColumnDef]="col.key">
            <!-- Added by amisha on 2026-08-24 to apply the configured width to application headers.
                 Reason: header and body cells must share the same fixed boundary for truncation. -->
            <!-- Updated by Amisha on 2026-08-27.
                 Reason: preserve configured header widths normally and release them only for fixed-width inline expansion. -->
            <!-- Updated by amisha on 2026-09-15.
                 Reason: retain configured application header widths while the mobile overlay is open. -->
            <th mat-header-cell
                *matHeaderCellDef
                [style.width]="fixedColumnWidths && showInlineExpansionInTable ? null : col.width"
                [style.minWidth]="fixedColumnWidths && showInlineExpansionInTable ? null : col.width"
                [style.maxWidth]="fixedColumnWidths && !showInlineExpansionInTable ? col.width : null"
                [class.sticky-col]="i === 0 && !showInitialSkeletonLoader"
                [class.first-data-column]="i === 1">

            <div class="header-cell header-flex">
              <!-- Added by furkan for optional sort icon 23-03-2026 -->
              <div [mat-sort-header]="col.key" class="header-sortable" [disabled]="col.sortable === false"
                [attr.tabindex]="disableHeaderKeyboardFocus ? -1 : null">
                <wm-common-text *ngIf="
                    col.headerType === 'text' ||
                    col.headerType === 'status' ||
                    col.headerType === 'badge'
                  " [data]="{ text: col.label }">
                </wm-common-text>
              </div>

            <!-- updated by furkan for instant update datatable and allow multiple selection-->
             <!-- Updated button added the condition in if block for application table and in that mobile view -->
              <button   *ngIf="!col.hideMenu && !(tableType === 'Applicant' && isMobileView)"
              mat-icon-button class="header-menu-btn"
                [attr.tabindex]="disableHeaderKeyboardFocus ? -1 : null"
                (click)="openColumnMenu($event)">
                <div class="header-menu-icon">
                  <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                </div>
              </button>
            </div>
          </th>
          <!-- Added by amisha on 05/07/2027 to support optional cell-level keyboard focus in shared tables.
               Reason: some shared-table consumers need direct cell activation without affecting tables that stay row-based. -->
          <!-- Added by amisha on 2026-08-24 to cap application cells at their configured width.
               Reason: long values must truncate inside the cell instead of shifting later columns. -->
          <!-- Updated by Amisha on 2026-08-27.
               Reason: preserve configured cell widths normally and release them only for fixed-width inline expansion. -->
          <!-- Updated by amisha on 2026-09-15.
               Reason: retain configured application cell widths while the mobile overlay is open. -->
          <td mat-cell *matCellDef="let row"
            [style.width]="fixedColumnWidths && showInlineExpansionInTable ? null : col.width"
            [style.minWidth]="fixedColumnWidths && showInlineExpansionInTable ? null : col.width"
            [style.maxWidth]="fixedColumnWidths && !showInlineExpansionInTable ? col.width : null"
            [class.sticky-col]="i === 0"
            [class.first-data-column]="i === 1"
            [class.keyboard-focusable-cell]="isCellKeyboardFocusable(col)"
            [attr.tabindex]="isCellKeyboardFocusable(col) ? 0 : null"
            [attr.role]="isCellKeyboardFocusable(col) ? 'button' : null"
            (keydown)="onCellKeydown($event, row, col)">
            <ng-container *ngIf="col.cellType === 'text'">
                      <!-- Updated by amisha on 09-02-2026 for expanded row click  in application table and staff table. -->
                      <!-- Added by amisha on 2026-04-03 to keep ellipsis text using the same tooltip behavior across desktop hover and touch-device tap flows. -->
                          <!-- Upated by amisha on 2026-04-14 to Keep normal row-click tables clickable on the text itself.
                               We only stop propagation inside `onTextCellClick` when a table is explicitly using cell expansion. -->
                      <div
                          class="row-cell flex-lengthy-cell"
                          (click)="onTextCellClick($event, row, col)"
                        >
                          <!-- Added by amisha on 2026-04-01 so inline-expanded rows can show the full cell value in a tooltip without changing normal table behavior. -->
                          <!-- Added by amisha on 2026-04-03 to reuse the same tooltip target for desktop hover and touch-device tap on truncated applicant text cells. -->
                          <span
                            #appTextTooltip="matTooltip"
                            class="cell-tooltip-target"
                            matTooltip=""
                            matTooltipTouchGestures="off"
                            matTooltipPosition="above"
                            matTooltipClass="custom-tooltip-style"
                            (mouseenter)="updateOverflowTooltip($event, appTextTooltip, row, col)"
                            (focusin)="updateOverflowTooltip($event, appTextTooltip, row, col)"
                            (click)="handleTouchTooltipClick($event, appTextTooltip, row, col)"
                            (mouseleave)="hideOverflowTooltip(appTextTooltip)"
                            (focusout)="hideOverflowTooltip(appTextTooltip)"
                          >
                            <wm-common-text [data]="{ text: row[col.key] }"></wm-common-text>
                          </span>
                        </div>
                      </ng-container>

            <!-- added by priya 09-03-2026 -->
                 <!-- Updated by amisha on 2024-04-14 to Reuse the same text-cell click rule here so applicant lengthy text
         opens the row/overlay normally unless the table is configured for expand-on-cell. -->
            <ng-container *ngIf="col.cellType === 'lengthyText'">
  <div
    class="row-cell flex-lengthy-cell"
    (click)="onTextCellClick($event, row, col)"
  >
    <!-- Added by amisha on 2026-04-03 to keep lengthy applicant text cells on the same shared tooltip behavior as other truncated table text. -->
    <span
      #appLengthyTooltip="matTooltip"
      class="cell-tooltip-target"
      matTooltip=""
      matTooltipTouchGestures="off"
      matTooltipPosition="above"
      matTooltipClass="custom-tooltip-style"
      (mouseenter)="updateOverflowTooltip($event, appLengthyTooltip, row, col)"
      (focusin)="updateOverflowTooltip($event, appLengthyTooltip, row, col)"
      (click)="handleTouchTooltipClick($event, appLengthyTooltip, row, col)"
      (mouseleave)="hideOverflowTooltip(appLengthyTooltip)"
      (focusout)="hideOverflowTooltip(appLengthyTooltip)">
      <wm-common-text
        [data]="{ text:row[col.key] }">
      </wm-common-text>
    </span>
  </div>
</ng-container>
            <!-- end by priya 09-03-2026 -->

            <ng-container *ngIf="col.cellType === 'status'">
              <div class="status-pill-bg"
                [matTooltip]="getInlineCellTooltip(row, col)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip-style">
                <div class="status-pill">
                  <wm-common-text [data]="{ text: row[col.key] }">
                  </wm-common-text>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="col.cellType === 'badge'">
              <div class="chat-icon-wrapper">
                <wm-common-icon [data]="{ iconName: col.icon }" (click)="onIconClick($event, col.icon, row)">
                </wm-common-icon>
              </div>
              <span *ngIf="col.badgeField && row[col.badgeField] > 0" class="chat-badge">
                {{ row[col.badgeField] }}
              </span>

            </ng-container>

            <ng-container *ngIf="col.cellType === 'icon'">
              <div class="icon-with-badge" [ngClass]="col.classFn?.(row)"
                [ngStyle]="{ '--dynamic-icon-color': col.iconColor?.(row) || null }">

                <wm-common-icon [data]="{ iconName: col.icon }" (click)="onIconClick($event, col.icon, row)">
                </wm-common-icon>

                <!-- 🔴 BADGE -->
                <span *ngIf="col.badgeField && row[col.badgeField] > 0" class="chat-badge">
                  {{ row[col.badgeField] }}
                </span>

              </div>
            </ng-container>


            <!--code commented by Krutika for disabling checkbox
             <ng-container *ngIf="col.cellType === 'checkbox'">
              <mat-checkbox class="custom_checkbox" [checked]="row.selected === true"
                (change)="checkboxSelect.emit(row)" (click)="$event.stopPropagation()">
              </mat-checkbox>
            </ng-container> -->
            <!-- Code added by Krutika for disabling checkbox -->
            <ng-container *ngIf="col.cellType === 'checkbox'">
              <mat-checkbox class="custom_checkbox" [checked]="row.selected === true"
                [disabled]="row.status === 'Disabled'" (change)="checkboxSelect.emit(row)"
                (click)="$event.stopPropagation()">
              </mat-checkbox>
            </ng-container>
            <ng-container *ngIf="col.cellType === 'radio'">
              <mat-radio-group [value]="row.selected === true ? row : null">
    <mat-radio-button class="custom_radio" [value]="row" (change)="selectRow(row)"
      (click)="$event.stopPropagation()">
    </mat-radio-button>
  </mat-radio-group>
            </ng-container>

            <ng-container *ngIf="col.cellType === 'component'">
              <ng-container [dynamicCellHost]="col.component"
                [componentInputs]="col.componentInputs ? col.componentInputs(row) : { row }"
                [componentOutputs]="col.componentOutputs">
              </ng-container>
            </ng-container>
          </td>
        </ng-container>
        <!-- ===== INLINE EXPANDED COLUMN (NEW) ===== -->
        <!-- Added by amisha on 25-02-2026 for inline expanded row card design in application table and staff table. -->
        <!-- Updated by amisha on 2026-09-15.
             Reason: keep the table-row close control only above mobile width; mobile uses the overlay back arrow. -->
        <!-- COLLAPSE COLUMN -->
        <ng-container matColumnDef="collapse">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">

            <mat-icon *ngIf="showInlineExpansionInTable && isExpanded(row)" (click)="collapseRow()" class="close-icon-cell">
              close
            </mat-icon>

          </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <!-- Updated by amisha on 25-02-2026 for expanded row click  in application table and staff table. -->
          <!-- Updated by amisha on 2026-09-15.
               Reason: prevent duplicate application detail rendering beneath the mobile overlay. -->
          <td mat-cell *matCellDef="let row" [attr.colspan]="effectiveDisplayedColumns.length"
            class="inline-expanded-cell">
            <ng-container *ngIf="showInlineExpansionInTable && isExpanded(row)">
              <!-- Added by amisha on 2026-04-01 to keep horizontal overflow inside the expanded panel instead of pushing the full table width. -->
              <div class="inline-expanded-shell">
                <div class="inline-expanded-scroll">
                  <ng-container [dynamicCellHost]="expandedComponent" [componentInputs]="
                      expandedComponentInputs
                        ? expandedComponentInputs(row)
                        : { row: row }
                    " [componentOutputs]="expandedComponentOutputs"></ng-container>
                </div>
              </div>
            </ng-container>
          </td>
        </ng-container>
        <!-- Updated by amisha on 25-02-2026 for inline expanded row card design in application table and staff table. -->
        <tr mat-header-row *matHeaderRowDef="effectiveDisplayedColumns"></tr>

        <!-- Added by amisha on 05/07/2027 to let shared-table consumers opt rows into keyboard navigation.
             Reason: My Applications needs full-row focus styling and row activation on Enter/Space. -->
        <tr mat-row *matRowDef="let row; columns: effectiveDisplayedColumns" (click)="onRowClick(row)"
          [class.expanded-active-row]="isExpanded(row)" [class.row-blocked]="expansionMode === 'inline' &&
expandedRow && !isExpanded(row)"
          [class.keyboard-focusable-row]="isRowKeyboardFocusable(row)"
          [attr.tabindex]="isRowKeyboardFocusable(row) ? 0 : null"
          (keydown)="onRowKeydown($event, row)"
          class="hover-active-row"></tr>


        <!-- INLINE EXPANDED ROW (NEW) -->
        <!-- Updated by amisha on 2026-09-15.
             Reason: show the extra application table row only when expansion is not in the mobile screen. -->
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="inline-expanded-row"
          [hidden]="!showInlineExpansionInTable || !isExpanded(row)"></tr>
      </table>
      <!-- Added by amisha on 04/20/2026 to render skeleton rows only inside the application body region.
           Reason: keep the fixed frame visible while page-change loading is in progress. -->
      <div *ngIf="showApplicationBodySkeletonLoader && loaderType === 'Skeleton'" class="table-body-skeleton-overlay">
        <div class="table-skeleton-wrapper">
          <div class="table-skeleton">
            <!-- Added by amisha on 04/20/2026 to generate a responsive loader row from the active table columns.
                 Reason: wide screens should show a full-width skeleton instead of a clipped five-column pattern. -->
            <div *ngFor="let r of skeletonRows" class="table-skeleton-row" [style.gridTemplateColumns]="skeletonGridTemplateColumns">
              <div *ngFor="let width of skeletonColumnWidths" class="table-skeleton-cell">
                <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px', width: '100%', borderRadius:'15px' }">
                </ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Added by amisha on 04/20/2026 to keep the circular refresh loader scoped to the application body only.
           Reason: avoid covering the fixed header and pagination frame. -->
      <div *ngIf="showApplicationBodySkeletonLoader && loaderType === 'Circular'" class="table-body-loader-overlay">
        <div class="data-table-loader">
          <mat-progress-spinner mode="indeterminate" diameter="48">
          </mat-progress-spinner>
          <wm-common-text [data]="{text:'Retrieving data, please waitâ€¦'}"></wm-common-text>
        </div>
      </div>
      <!-- added by priya 10-02-2026 -->
      <!-- <mat-progress-bar *ngIf="loadingData && !isLoading" mode="indeterminate"></mat-progress-bar> -->

      <!-- end by priya 10-02-2026 -->

       <!-- added by omkar 30-03-2026 -->
      <mat-progress-bar
        *ngIf="effectiveLoadingData && !showSkeletonDataLoader && tableType !== 'Applicant'"
        class="table-linear-progress"
        mode="indeterminate">
      </mat-progress-bar>
      <!-- end by omkar 30-03-2026 -->

      <!-- OVERLAY MODE (NEW) -->
      <div class="table-body-overlay" *ngIf="expansionMode === 'overlay' && expandedRow">
        <ng-container [dynamicCellHost]="expandedComponent" [componentInputs]="
            expandedComponentInputs
              ? expandedComponentInputs(expandedRow)
              : { row: expandedRow }
          " [componentOutputs]="expandedComponentOutputs"></ng-container>
      </div>
      <!-- Added by amisha on 04/20/2026 so empty-state content does not appear under the refresh skeleton.
           Reason: the loader should be the only body content during application refresh. -->
      <ng-container  *ngIf="
          !showApplicationBodySkeletonLoader &&   !showInitialSkeletonLoader &&
(!dataSource?.data || dataSource.data.length === 0)
        ">
        <ng-container *ngIf="!effectiveLoadingData">

          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

      <ng-container *ngIf="tableType === 'Staff'">
        <!-- Added by amisha on 2026-04-01 to switch inline-expansion layout only while a row is open and avoid changing the default table width. -->
        <!-- Added by amisha on 04/20/2026 to hide only fixed-scroll staff rows during refresh.
             Reason: the fixed-scroll implementation should keep the frame while body skeletons render. -->
        <!-- Added by amisha on 2026-08-24 to support opt-in fixed widths in the staff render path.
             Reason: the Janus applications grid uses this path and must remain stable during server-side sorting. -->
        <!-- Updated by Amisha on 2026-08-27.
             Reason: release fixed widths only while inline expansion is open so the expanded card fits the viewport. -->
        <!-- Updated by amisha on 2026-09-15.
             Reason: keep staff table widths stable while the mobile details render outside the table. -->
        <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
          [class.fixed-column-widths]="fixedColumnWidths && !showInlineExpansionInTable"
          [class.initial-skeleton-table]="showInitialSkeletonLoader"
          [class.body-loading-table]="showFixedScrollSkeletonLoader"
          [class.inline-expansion-table]="showInlineExpansionInTable"
          (matSortChange)="handleSortChange($event)">
          <ng-container *ngFor="let col of columns" [matColumnDef]="col.key">
  <!-- Added by amisha on 2026-08-24 to fix staff header cells to their configured width.
       Reason: header alignment must remain identical for every sorted result set. -->
  <!-- Updated by Amisha on 2026-08-27.
       Reason: preserve configured header widths normally and release them only for fixed-width inline expansion. -->
  <!-- Updated by amisha on 2026-09-15.
       Reason: retain configured staff header widths while the mobile overlay is open. -->
  <th mat-header-cell *matHeaderCellDef
              [ngClass]="{
                'sticky-col': col.key === columns[0].key,
                'sticky-checkbox-col': col.key === columns[0].key && col.headerType === 'checkbox'
              }"
              [style.width]="fixedColumnWidths && showInlineExpansionInTable ? null : col.width"
    [style.minWidth]="fixedColumnWidths && showInlineExpansionInTable ? null : col.width"
    [style.maxWidth]="fixedColumnWidths && !showInlineExpansionInTable ? col.width : null"
    [class.header-align-top]="col.headerAlignTop"
    >
              <div class="header-cell header-flex">
                <div style="display: flex; align-items: center; justify-content: center; flex-direction: row;">
                  <!-- Added by furkan for optional sort icon 23-03-2026 -->
                  <div [mat-sort-header]="col.key" class="header-sortable" [disabled]="col.sortable === false"
                    [attr.tabindex]="disableHeaderKeyboardFocus ? -1 : null">
                    <ng-container [ngSwitch]="col.headerType">
                      <ng-container *ngSwitchCase="'text'">
                        <wm-common-text [data]="{ text: col.label }"></wm-common-text>
                      </ng-container>
                      <!-- Added by amisha on 25-02-2026 for checkbox select all in header in staff table. -->
                      <!-- CHECKBOX HEADER -->
                      <ng-container *ngSwitchCase="'checkbox'">
                        @if(!expandedRow) {
                        <mat-checkbox class="custom_checkbox" [checked]="isAllSelectedStaff()"
                          [indeterminate]="isSomeSelectedStaff()" (change)="toggleSelectAllStaff($event.checked)"
                          (click)="$event.stopPropagation()">
                        </mat-checkbox>
                        }

                      </ng-container>
                      <ng-container *ngSwitchCase="'icon'">
                        <div class="header-menu-icon" [matTooltip]="col.label" matTooltipPosition="above">
                          <wm-common-icon [data]="{ iconName: col.icon }"></wm-common-icon>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'template'">
                        <ng-container *ngTemplateOutlet="col.headerTemplate;"></ng-container>
                      </ng-container>

                    </ng-container>
                  </div>
                <!-- updated by furkan for instant update datatable and allow multiple selection-->
                  <ng-container *ngIf="!col.hideMenu">
                    <button mat-icon-button class="header-menu-btn"
                      [attr.tabindex]="disableHeaderKeyboardFocus ? -1 : null"
                      (click)="openColumnMenu($event)">
                      <div class="header-menu-icon">
                        <wm-common-icon [data]="{ iconName: 'more_vert' }"></wm-common-icon>
                      </div>
                    </button>
                  </ng-container>
                    <!-- ended by furkan for instant update datatable and allow multiple selection-->
                </div>
              </div>
            </th>

            <!-- Added by amisha on 05/07/2027 to keep staff-table support for optional cell keyboard focus.
                 Reason: the shared table needs the same keyboard contract in both application and staff render paths. -->
 <!-- Added by amisha on 2026-08-24 to cap staff cells at their configured width.
      Reason: varying row text must truncate without increasing or decreasing preceding columns. -->
 <td mat-cell *matCellDef="let row" [ngStyle]="!expandedRow ? { width: col.width, minWidth: col.width, maxWidth: fixedColumnWidths ? col.width : null } : null"
              [ngClass]="{
                'sticky-col': col.key === columns[0].key,
                'sticky-checkbox-col': col.key === columns[0].key && col.cellType === 'checkbox'
              }"
              [class.keyboard-focusable-cell]="isCellKeyboardFocusable(col)"
              [attr.tabindex]="isCellKeyboardFocusable(col) ? 0 : null"
              [attr.role]="isCellKeyboardFocusable(col) ? 'button' : null"
              (keydown)="onCellKeydown($event, row, col)">
              <ng-container *ngIf="col.cellType === 'text'">
                <!-- Added by amisha  for differet cell color depending on application and staff table on 21-01-2026 -->
                                 <!-- Updated by amisha on 2024-04-14 Staff text cells use the same handler so inline expansion keeps working,
                     while standard row-click behavior is no longer blocked by the text wrapper. -->
                <div class="row-cell flex-lengthy-cell" [ngStyle]="{
                  '--cell-text-color': col.textColor || null,
                  '--cell-font-weight': col.fontWeight || null,
                  cursor: col?.cursor || null
                }"
                (click)="onTextCellClick($event, row, col)">
                <!-- Added by amisha on 2026-04-03 to keep staff table text using the same truncated-text tooltip flow across hover and tap. -->
                <span
                  #staffTextTooltip="matTooltip"
                  class="cell-tooltip-target"
                  matTooltip=""
                  matTooltipTouchGestures="off"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip-style"
                  (mouseenter)="updateOverflowTooltip($event, staffTextTooltip, row, col)"
                  (focusin)="updateOverflowTooltip($event, staffTextTooltip, row, col)"
                  (click)="handleTouchTooltipClick($event, staffTextTooltip, row, col)"
                  (mouseleave)="hideOverflowTooltip(staffTextTooltip)"
                  (focusout)="hideOverflowTooltip(staffTextTooltip)">
                  <wm-common-text [data]="{ text: row[col.key] }"></wm-common-text>
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="col.cellType === 'status'">
              <div class="row-cell">
                <span
                class="cell-tooltip-target"
                [matTooltip]="getInlineCellTooltip(row, col)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip-style">
                  <wm-common-text [data]="{ text: row[col.key] }">
                  </wm-common-text>
                </span>
                </div>
            </ng-container>
              <ng-container *ngIf="col.cellType === 'icon'">
                <div class="icon-with-badge" [ngClass]="col.classFn?.(row)"
                  [ngStyle]="{ '--icon-color': col.iconColor?.(row) || null }">

                  <wm-common-icon [data]="{ iconName: col.icon }" (click)="onIconClick($event, col.icon, row)">
                  </wm-common-icon>

                  <!-- 🔴 BADGE -->
                  <span *ngIf="col.badgeField && row[col.badgeField] > 0" class="chat-badge">
                    {{ row[col.badgeField] }}
                  </span>

                </div>
              </ng-container>
              <ng-container *ngIf="col.cellType === 'component'">
                <!-- <ng-container *ngComponentOutlet="col.component"></ng-container> -->
                <ng-container [dynamicCellHost]="col.component"
                  [componentInputs]="col.componentInputs ? col.componentInputs(row) : { row }"
                  [componentOutputs]="col.componentOutputs">
                </ng-container>
              </ng-container>
              <ng-container *ngIf="col.cellType === 'checkbox'">
                @if(!expandedRow ) {
                <mat-checkbox class="custom_checkbox" [checked]="row.selected === true"
                  (change)="onStaffRowCheckboxClick(row, $event.checked)" (click)="$event.stopPropagation()">
                </mat-checkbox>
                }

              </ng-container>
              <ng-container *ngIf="col.cellType === 'template'">
                <ng-container *ngTemplateOutlet="col.cellTemplate; context: { $implicit: row }">
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
          <!-- ===== INLINE EXPANDED COLUMN (NEW) ===== -->
          <!-- Added by amisha on 25-02-2026 for inline expanded row card design in application table and staff table. -->
          <!-- Updated by amisha on 2026-09-15.
               Reason: keep the table-row close control only above mobile width; mobile uses the overlay back arrow. -->
          <!-- COLLAPSE COLUMN -->
          <ng-container matColumnDef="collapse">
            <th mat-header-cell *matHeaderCellDef></th>

            <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">

              <mat-icon *ngIf="showInlineExpansionInTable && isExpanded(row)" (click)="collapseRow()"
                class="close-icon-cell">
                close
              </mat-icon>

            </td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <!-- Updated by amisha on 2026-09-15.
                 Reason: prevent duplicate staff detail rendering beneath the mobile overlay. -->
            <td mat-cell *matCellDef="let row" [attr.colspan]="effectiveDisplayedColumns.length"
              class="inline-expanded-cell">
              <ng-container *ngIf="showInlineExpansionInTable && isExpanded(row)">

                <div class="inline-expanded-shell">
                  <div class="inline-expanded-scroll">
                    @if (expansionTemplate) {
                    <ng-container *ngTemplateOutlet="expansionTemplate; context: { $implicit: row }">
                    </ng-container>
                    }@else {
                    <ng-container [dynamicCellHost]="expandedComponent" [componentInputs]="
                  expandedComponentInputs
                    ? expandedComponentInputs(row)
                    : { row: row }
                " [componentOutputs]="expandedComponentOutputs"></ng-container>
                    }
                  </div>
                </div>
              </ng-container>
            </td>
          </ng-container>
          <!-- Updated by amisha on 25-02-2026 for inline expanded row click  in application table and staff table. -->

          <tr mat-header-row *matHeaderRowDef="effectiveDisplayedColumns"></tr>
          <!--Code commented by Krutika
         <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"></tr> -->
          <!-- Code added by Krutika for disabling row-->
          <!-- // Updated by amisha on 25-02-2026 for inline expanded row click  in application table and staff table. -->


          <!-- Added by amisha on 05/07/2027 to expose keyboard-focusable rows for the staff-table render path too.
               Reason: row-level keyboard behavior is configured in the shared component rather than duplicated per page. -->
          <tr mat-row *matRowDef="let row; columns: effectiveDisplayedColumns"
            (click)="row.status !== 'Disabled' && onRowClick(row)" [class.row-disabled]="row.status === 'Disabled'" [class.row-selected]="row.selected === true"
            [class.row-blocked]="
  expansionMode === 'inline' &&
  expandedRow &&
  !isExpanded(row)"
  [class.expanded-active-row]="isExpanded(row)"
            [class.keyboard-focusable-row]="isRowKeyboardFocusable(row)"
            [attr.tabindex]="isRowKeyboardFocusable(row) ? 0 : null"
            (keydown)="onRowKeydown($event, row)">
          </tr>
          <!-- INLINE EXPANDED ROW (NEW) -->
          <!-- Updated by amisha on 2026-09-15.
               Reason: show the extra staff table row only when expansion is not in the mobile screen. -->
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="inline-expanded-row"
            [hidden]="!showInlineExpansionInTable || !isExpanded(row)"></tr>
        </table>
        <!-- Added by amisha on 04/20/2026 to render skeleton rows only inside the fixed-scroll staff body.
             Reason: preserve the fixed header and pagination in the first implementation while loading. -->
        <div *ngIf="showFixedScrollSkeletonLoader && loaderType === 'Skeleton'" class="table-body-skeleton-overlay">
          <div class="table-skeleton-wrapper">
            <div class="table-skeleton">
              <!-- Added by amisha on 04/20/2026 to generate a responsive loader row from the active table columns.
                   Reason: the fixed-scroll loader should scale with both screen width and visible column count. -->
              <div *ngFor="let r of skeletonRows" class="table-skeleton-row" [style.gridTemplateColumns]="skeletonGridTemplateColumns">
                <div *ngFor="let width of skeletonColumnWidths" class="table-skeleton-cell">
                  <ngx-skeleton-loader appearance="circle" [theme]="{ height: '20px', width: '100%', borderRadius:'15px' }">
                  </ngx-skeleton-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Added by amisha on 04/20/2026 to scope the circular refresh loader to the fixed-scroll staff body only.
             Reason: the table frame should stay visible during refresh. -->
        <div *ngIf="showFixedScrollSkeletonLoader && loaderType === 'Circular'" class="table-body-loader-overlay">
          <div class="data-table-loader">
            <mat-progress-spinner mode="indeterminate" diameter="48">
            </mat-progress-spinner>
            <wm-common-text [data]="{text:'Retrieving data, please waitâ€¦'}"></wm-common-text>
          </div>
        </div>
        <!-- added by priya 10-02-2026 -->
        <!-- <mat-progress-bar *ngIf="loadingData && !isLoading" mode="indeterminate"></mat-progress-bar> -->
        <!-- end by priya 10-02-2026 -->

        <!-- added by omkar 30-03-2026 -->
        <mat-progress-bar *ngIf="effectiveLoadingData && !showSkeletonDataLoader" class="table-linear-progress"
          mode="indeterminate">
        </mat-progress-bar>
        <!-- end by omkar 30-03-2026 -->

        <!-- Added by amisha on 04/20/2026 to suppress the empty state while either staff refresh loader is active.
             Reason: avoid mixing "No Data" with body-collapsed or body-skeleton loading states. -->
        <ng-container *ngIf="
          !showInitialSkeletonLoader &&
          !showCollapsedBodyLoader &&
          !showFixedScrollSkeletonLoader &&
          (!dataSource?.data || dataSource.data.length === 0)
        ">
          <ng-container *ngIf="!effectiveLoadingData">

            <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- OVERLAY MODE (NEW) -->
      <div class="table-body-overlay" *ngIf="expansionMode === 'overlay' && expandedRow">
        <ng-container [dynamicCellHost]="expandedComponent" [componentInputs]="
          expandedComponentInputs
            ? expandedComponentInputs(expandedRow)
            : { row: expandedRow }
        " [componentOutputs]="expandedComponentOutputs"></ng-container>
      </div>

    </ng-container>
  </div>

  <!-- Added by amisha on 2026-09-15.
       Reason: show staff/application inline details as a full mobile screen with a back arrow,
       selected application number, and support for existing template or dynamic detail content. -->
  <!-- Added by Amisha on 2026-09-29.
       Reason: scope body-only App View scrolling to staff inline expansions and preserve applicant behavior. -->
  <div
    *ngIf="showMobileInlineExpansionOverlay"
    #mobileInlineOverlay
    class="mobile-inline-expansion-overlay"
    [class.staff-mobile-inline-expansion]="tableType === 'Staff'"
    role="dialog"
    aria-modal="true"
  >
    <div class="mobile-inline-expansion-panel">
      <div class="mobile-inline-expansion-header">
        <button
          type="button"
          class="mobile-inline-expansion-back"
          [attr.aria-label]="'Back from ' + mobileInlineExpansionHeaderTitle"
          (click)="collapseRow()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <!-- Updated by Amisha on 2026-09-21.
             Reason: show the application number when available, otherwise the parent page and subtab title. -->
        <span class="mobile-inline-expansion-title">
          {{ mobileInlineExpansionHeaderTitle }}
        </span>
      </div>
      <div class="mobile-inline-expansion-content">
        @if (expansionTemplate) {
          <ng-container *ngTemplateOutlet="expansionTemplate; context: { $implicit: expandedRow }">
          </ng-container>
        } @else {
          <ng-container
            [dynamicCellHost]="expandedComponent"
            [componentInputs]="expandedComponentInputs ? expandedComponentInputs(expandedRow) : { row: expandedRow }"
            [componentOutputs]="expandedComponentOutputs">
          </ng-container>
        }
      </div>
    </div>
  </div>

  <ng-template #noDataTemplate>
    <div class="no-data-wrapper">
      <wm-common-text class="no-data-text" [data]="{ text: 'No Data Found' }"></wm-common-text>
    </div>
  </ng-template>

  <!--Deepak added on 23-03-2026 for column setting menu in application and staff table. -->
  <!-- updated by furkan for instant update datatable and allow multiple selection-->
  <!-- Added by amisha on 2026-06-01 to pass per-screen column-limit rules into the shared settings menu.
       Reason: Janus must block the 8th visible column and show a toaster instead of saving invalid state. -->
  <app-column-settings-menu #columnMenuComp [columns]="columns" [displayedColumns]="displayedColumns"
    [exportColumns]="exportColumns" [hasExportOptions]="hasExportOptions"
    [updateOnClose]="updateColumnsOnClose"
    [maxVisibleColumns]="maxVisibleColumns"
    [maxVisibleColumnsMessage]="maxVisibleColumnsMessage"
    (toggleColumn)="toggleColumn($event)"
    (visibleColumnLimitReached)="visibleColumnLimitReached.emit($event)"
    (toggleExport)="toggleExportColumn($event)"
    (displayedColumnsUpdated)="onDisplayedColumnsUpdated($event)">
  </app-column-settings-menu>
  <div #menuProxyTrigger
       [matMenuTriggerFor]="columnMenuComp?.menu"
       style="position: fixed; opacity: 0; pointer-events: none; z-index: -1000;">
  </div>
  <!-- End of code added by Deepak on 23-03-2026 for column setting menu in application and staff table. -->
  <!-- added by omkar khamkar on 2026-03-23 -->

  <!-- Added by amisha on 05/07/2027 to let pages control whether pagination remains keyboard-focusable.
       Reason: shared-table consumers may want to keep pagination in the tab order while customizing row/header focus rules. -->
  <wm-common-pagination class="common-table-pagination" *ngIf="shouldShowPagination" [data]="paginationData"
    [disableKeyboardFocus]="disablePaginationKeyboardFocus"   [class.mobile-tablet-scrolling-pagination]="isMobileTabletViewScrollingAndPaginationChanges"
    (pageSizeChange)="onPageSizeChange($event)" (pageSelect)="goToPage($event)" (first)="goToFirst()"
    (previous)="goToPrevious()" (next)="goToNext()" (last)="goToLast()">
  </wm-common-pagination>
</div>
<!-- end by omkar khamkar on 2026-03-23 -->
<wm-common-confirmation-modal [data]="closeInlineApplicationModalData" (onYesClick)="handleCloseInlineApplicationModalAccepted()"
    (onNoClick)="handleCloseInlineApplicationModalRejected()">
</wm-common-confirmation-modal>
